import { combineReducers } from "@reduxjs/toolkit";
import { createReduxHistoryContext } from "redux-first-history";
import { reducer as form } from "redux-form";

import { EMAIL, PERSON, QUESTION, TAG } from "../actions/types";
import history from "../../history";
import authReducer from "../reducers/authReducer";
import createEntryListReducer from "../reducers/entryListReducer";
import projectsReducer from "../reducers/projectsReducer";
import foldersReducer from "../reducers/foldersReducer";
import localRecordingReducer from "../reducers/localRecordingReducer";
import organizationsReducer from "../reducers/organizationsReducer";
import prepareReducer from "../reducers/prepareReducer";
import prepSessionsReducer from "../reducers/prepSessionsReducer";
import uploadFilesReducer from "../reducers/uploadFilesReducer";
import concludeReducer from "../reducers/concludeReducer";
import { theirStoryAPI } from "../../api/theirStoryAPI";
import clipsReducer from "../reducers/clipsReducer";
import dailyCallReducer from "../reducers/dailyCallReducer";
import galleriesReducer from "../reducers/galleriesReducer";
import remixesReducer from "../reducers/remixesReducer";

import { webUiV2ReducerSlices } from "./inheritFromWeeb-ui-v2/state/rootReducer";
import call from "./call/reducer";
import storiesReducer from "./stories/reducer";
import featureFlagReducer from "./feature_flagging/reducer";
import modalsReducer from "./modals/reducer";
import storyAuthoringReducer from "./story_authoring/reducer";

export const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history,
  // other options if needed
});

export const rootReducer = combineReducers({
  form,
  auth: authReducer,
  prepare: prepareReducer,
  prepsessions: prepSessionsReducer,
  prepare_questions: createEntryListReducer(QUESTION),
  prepare_participants: createEntryListReducer(PERSON),
  conclude_tags: createEntryListReducer(TAG),
  conclude_participants: createEntryListReducer(PERSON),
  conclude_emails: createEntryListReducer(EMAIL),
  projects: projectsReducer,
  folders: foldersReducer,
  stories: storiesReducer,
  organizations: organizationsReducer,
  router: routerReducer,
  modals: modalsReducer,
  storyAuthoring: storyAuthoringReducer,
  call,
  localRecording: localRecordingReducer,
  featureFlags: featureFlagReducer,
  uploadFiles: uploadFilesReducer,
  conclude: concludeReducer,
  clips: clipsReducer,
  dailyCall: dailyCallReducer,
  galleries: galleriesReducer,
  remixes: remixesReducer,
  ...webUiV2ReducerSlices,
  [theirStoryAPI.reducerPath]: theirStoryAPI.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
